module.exports = __webpack_public_path__ + "static/media/icon_web.24d8456e.svg";